import { render, staticRenderFns } from "./alltable.vue?vue&type=template&id=59634129&scoped=true&"
import script from "./alltable.vue?vue&type=script&lang=js&"
export * from "./alltable.vue?vue&type=script&lang=js&"
import style0 from "./alltable.vue?vue&type=style&index=0&id=59634129&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59634129",
  null
  
)

export default component.exports